import * as api from '../apis/organizations';
import { apiCall } from '~/lib/redux/api';
import { EntityActions, OrganizationActions } from './consts';
import { OrgNormalizer } from './normalize';
import { defaultTablePageSize } from '~/common/components/consts';


export function getOrganizationById(orgId) {
  return apiCall({
    actions: [
      OrganizationActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, OrganizationActions.LOAD_SUCCESS],
      OrganizationActions.LOAD_ERROR,
    ],
    normalizer: OrgNormalizer,
    fn: () => api.getOrganizationById(orgId),
  });
}

// TODO: Use constants
export function getOrganizations(offset = 0, limit = defaultTablePageSize) {
  return apiCall({
    actions: [
      OrganizationActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, OrganizationActions.LOAD_LIST_SUCCESS],
      OrganizationActions.LOAD_ERROR,
    ],
    normalizer: [OrgNormalizer],
    fn: () => api.getOrganizations(offset, limit),
  });
}

export function setOrganizationsCurrentPage(page = 0) {
  return {
    type: OrganizationActions.SET_CURRENT_PAGE,
    currentPage: page,
  }
}
